import {Fragment} from 'react';
// @ts-expect-error
import {Transition} from '@headlessui/react';

interface TransitionVisibleProps {
  show: boolean;
  children: React.ReactNode;
}

export function TransitionVisible({show, children}: TransitionVisibleProps) {
  return (
    <Transition
      as={Fragment}
      show={show}
      enter="transform transition duration-[400ms]"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transform duration-200 transition ease-in-out"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      {children}
    </Transition>
  );
}
